import React from "react";
import Footer from "../../components/Footer";
import Masters from "../../components/Masters";
import NavBar from "../../components/navbar/NavBar";

const MastersPage = () => {
  return (
    <div>
      <NavBar />
      <Masters />
      <Footer />
    </div>
  );
};

export default MastersPage;
